import { Outlet } from "react-router-dom";
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import "./style.css";

function AppContent() {
  
  return (
    <div className="app-content">
      <Navbar />

      <div className="outlet">
        {
          <Outlet /> 
        }

      </div>

      <Footer />
    </div>
  );
}

export default AppContent;
